import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { of } from 'rxjs';
import { AccountService } from '../services/account/account.service';

export const internalGuardMatch: CanMatchFn = (route, segments) => {
  const account = inject(AccountService);
  return of(account.isInternal);
};
